import { environment } from './../../../environment/environment';
import { TutoService } from './../../core/services/tuto/tuto.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { serverError } from './../../core/models/messages';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-tutoclient',
  templateUrl: './tutoclient.component.html',
  styleUrls: ['./tutoclient.component.css'],
})
export class TutoclientComponent {
  listTuto: any[] = [];
  loadSpinner: boolean = false;
  loadSpinnerTable: boolean = false;
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  /* pagination */
  totalItems: number = 10;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  startIndex: number = 0;
  endIndex: number = 10;

  showFullDescription = false;
  showFullText: any;
  maxLength = 40;
  safeUrl!: SafeResourceUrl;
  displayURL: any;

  /*videoLinks*/
  videoLinks: string[] = [];
  intervalId: any;
  newListTuto: any;
  currentVideoIndex = 0;
  isVideoPlaybackInProgress = false;
  getTutoState = false;
  howFullText: boolean[] = [];
  pagination : boolean =false;

  currentPlayingVideo: number | null = null;
  url: string = environment.baseUrl + '/api/Tuto/file/tutosFiles/';
  constructor(
    private tutoService: TutoService,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.spinner.show();
    this.loadSpinnerTable = true;
    if (!this.getTutoState) {
      this.getListTuto(this.itemsPerPage, this.currentPage);
    }
    this.applyFilter();
  }

  getListTuto(per_page: number, page: number) {
    this.spinner.show();
    this.tutoService
      .getAllTutoclient(per_page, page)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('resss', res);
          if (res.status == 200) {
            this.getTutoState = true;

            this.totalItems = res.data.total;
            this.listTuto = res.data.data
            // .slice(0, this.endIndex);
            // this.listTuto = res.data.data.reverse().slice(0, this.endIndex)
            this.showFullText = new Array(this.listTuto.length).fill(false);

            if (this.listTuto.length) {
              this.listTuto.forEach((element: any) => {
                this.videoLinks.push(element.link);
              });
            }

            this.listTuto = this.listTuto.map((item) => ({
              ...item,
              show_video: false,
            }));
          }
          this.spinner.hide();
          this.loadSpinnerTable = false;
        },
        error: (err: Error) => {
          this.toastrService.error(serverError);
          this.spinner.hide();
          this.loadSpinnerTable = false;
        },
      });
  }

  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }

  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }

  /* get pagination items */
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
        if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){          
          this.pagination = true
      this.getListTuto(this.itemsPerPage, this.currentPage);
        }
    }
  }

  displayVideo(link: string, index: number) {
    const videoId = this.getVideoIdFromURL(link);
    // Create the embedded YouTube URL
    const displayURL = `https://www.youtube.com/embed/${videoId}`;
    this.listTuto[index].displayURL =
      this.sanitizer.bypassSecurityTrustResourceUrl(displayURL);
    this.isVideoPlaybackInProgress = false;
  }

  private getVideoIdFromURL(url: string): string {
    const match = url.match(/v=([a-zA-Z0-9_-]+)/);
    if (match && match[1]) {
      return match[1];
    }
    return '';
  }

  showVideo(link: any, index: any) {
    if (this.currentPlayingVideo !== null) {
      // Check if there's a currently playing video
      this.stopVideo(this.currentPlayingVideo);
    }

    const videoId = this.getVideoIdFromURL(link);
    const displayURL = `https://www.youtube.com/embed/${videoId}`;
    this.listTuto[index].displayURL =
      this.sanitizer.bypassSecurityTrustResourceUrl(displayURL);
    this.listTuto[index].show_video = true;

    this.currentPlayingVideo = index;
  }

  stopVideo(index: number) {
    if (this.listTuto[index].show_video) {
      this.listTuto[index].show_video = false;
      this.currentPlayingVideo = null;
    }
  }
  reset() {
    this.currentPage = 1;
    this.searchFormGroup.reset();
    this.searchFormGroup = this.createSearchForm();
    this.applyFilter();
  }

  searchFormGroup: FormGroup = this.createSearchForm();
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      search: ['', data?.search],
      type: ['', data?.type],
    });
  }
  listtuto: any;
  applyFilter() {
    this.spinner.show();
    let data = {
      type: 3,
      search: this.searchFormGroup.value.search,
    };
    this.spinner.show();
    this.tutoService
      .searchtuto(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.listTuto = res.data.items.data;
          console.log('listetuto', this.listTuto);
          this.totalItems = res.data.items.total;
          console.log('total', this.totalItems);
          this.spinner.hide();
          if (this.listTuto.length === 0) {
            this.noResults();
            this.spinner.hide();
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastrService.error('Erreur serveur');
        },
      });
  }

  noResults() {
    this.spinner.hide();
    this.listTuto = [];
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
